import { useState, useRef, useEffect } from 'react';
import { ChevronDown } from 'lucide-react';
import { CURRENCIES, getCurrency } from '../lib/currency';
import { useCurrencyStore } from '../store/useStore';

export function CurrencySelector({ compact = false }) {
  const { currency, setCurrency } = useCurrencyStore();
  const [open, setOpen] = useState(false);
  const ref = useRef(null);
  const current = getCurrency(currency);

  useEffect(() => {
    const handler = (e) => { if (ref.current && !ref.current.contains(e.target)) setOpen(false); };
    document.addEventListener('mousedown', handler);
    return () => document.removeEventListener('mousedown', handler);
  }, []);

  return (
    <div ref={ref} style={{ position: 'relative', display: 'inline-block' }}>
      <button
        onClick={() => setOpen(o => !o)}
        style={{
          display: 'flex', alignItems: 'center', gap: 4,
          padding: compact ? '3px 8px' : '4px 10px',
          borderRadius: 8, border: '1px solid #e5e7eb',
          background: '#fff', cursor: 'pointer', fontSize: 12,
          color: '#374151', fontWeight: 500,
          whiteSpace: 'nowrap',
        }}
        title="Cambiar moneda"
      >
        <span>{current.flag}</span>
        {!compact && <span>{current.code}</span>}
        <ChevronDown style={{ width: 12, height: 12, color: '#9ca3af' }} />
      </button>

      {open && (
        <div style={{
          position: 'absolute', top: '110%', right: 0, zIndex: 9999,
          background: '#fff', border: '1px solid #e5e7eb', borderRadius: 10,
          boxShadow: '0 4px 20px rgba(0,0,0,0.12)',
          minWidth: 200, maxHeight: 320, overflowY: 'auto', padding: '4px 0',
        }}>
          {CURRENCIES.map(c => (
            <button
              key={c.code}
              onClick={() => { setCurrency(c.code); setOpen(false); }}
              style={{
                display: 'flex', alignItems: 'center', gap: 8,
                width: '100%', padding: '7px 14px', background: 'none',
                border: 'none', cursor: 'pointer', fontSize: 12, textAlign: 'left',
                color: currency === c.code ? '#f97316' : '#374151',
                fontWeight: currency === c.code ? 700 : 400,
                backgroundColor: currency === c.code ? '#fff7ed' : 'transparent',
              }}
            >
              <span style={{ fontSize: 16 }}>{c.flag}</span>
              <span style={{ fontWeight: 600 }}>{c.code}</span>
              <span style={{ color: '#9ca3af', fontSize: 11 }}>{c.name}</span>
            </button>
          ))}
        </div>
      )}
    </div>
  );
}
